<!--
 * @Author: Junjie
 * @Date: 2022-05-30 23:28:11
 * @LastEditTime: 2022-06-02 16:41:59
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/video/live.vue
-->
<template>
  <a-row :gutter="16" type="flex">
    <a-col :md="6" :sm="24">
      <div style="height: 85vh;background-color: #fff;">
        <!-- <a-input-search @search="keyWordSearch" enterButton placeholder="搜索" style="width:80%;margin:10px auto" /> -->
        <a-tree :expandedKeys="['root']" :treeData="devices" @select="selectDevice" autoExpandParent>
          <a-icon slot="online" type="camera" />
        </a-tree>
      </div>
    </a-col>
    <a-col :md="24-6" :sm="24">
      <a-card :bordered="false">
        <span slot="extra">
          分屏:
          <a-radio-group @change="changeSplit" button-style="solid" v-model="splitNum">
            <a-radio-button value="1">单屏</a-radio-button>
            <a-radio-button value="4">四分屏</a-radio-button>
            <a-radio-button value="9">九分屏</a-radio-button>
          </a-radio-group>

          <a-divider type="vertical" />
          <a-button icon="fullscreen">全屏</a-button>
        </span>
        <div
          style="width: 99%;height: 80vh;display: flex;flex-wrap: wrap;align-items: center; justify-content: space-evenly;background-color: #000;"
        >
          <div
            :class="{redborder:playerIdx == (i-1)}"
            :key="i"
            :style="liveStyle"
            @click="playerIdx = (i-1)"
            class="play-box"
            v-for="i in  spilt"
          >
            <div style="color: #ffffff;font-size: 30px;font-weight: bold;" v-if="!videoUrl[i-1]">{{ i }}</div>
            <player
              :videoUrl="videoUrl[i-1]"
              @destroy="destroy"
              @screenshot="shot"
              autoplay
              fluent
              ref="player"
              v-else
            />
          </div>
        </div>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
  import player from './modules/jessibuca.vue'
  import { getAction } from '@/api/manage'
  export default {
    name: "live",
    components: {
      player
    },
    data () {
      return {
        keyWordSearch: '',
        devices: [],
        videoUrl: [''],
        splitNum: "1",
        spilt: 1,//分屏
        playerIdx: 0,//激活播放器

        updateLooper: 0, //数据刷新轮训标志
        count: 15,
        total: 0,

        //channel
        loading: false,
        url: {
          getDeviceList: "/video/videoDevice/list",
          getPointsGrouplist: '/monitor/iotModelPointsGroup/list',
          getPointData: '/monitor/data/pointdata'
        }
      };
    },
    mounted () {

    },
    created () {
      this.checkPlayByParam()
      this.getDeviceList();
    },

    computed: {
      liveStyle () {
        let style = { width: '100%', height: '100%' }
        switch (this.spilt) {
          case 4:
            style = { width: '49%', height: '49%' }
            break
          case 9:
            style = { width: '32%', height: '32%' }
            break
        }
        this.$nextTick(() => {
          for (let i = 0; i < this.spilt; i++) {
            const player = this.$refs.player
            player && player[i] && player[i].updatePlayerDomSize()
          }
        })
        return style
      }
    },
    watch: {
      spilt (newValue) {
        console.log("切换画幅;" + newValue)
        let that = this
        for (let i = 1; i <= newValue; i++) {
          if (!that.$refs['player' + i]) {
            continue
          }
          this.$nextTick(() => {
            if (that.$refs['player' + i] instanceof Array) {
              that.$refs['player' + i][0].resize()
            } else {
              that.$refs['player' + i].resize()
            }
          })

        }
        window.localStorage.setItem('split', newValue)
      },
      '$route.fullPath': 'checkPlayByParam'
    },
    destroyed () {
      clearTimeout(this.updateLooper);
    },
    methods: {
      getDeviceList () {
        getAction(this.url.getDeviceList, {}).then((res) => {
          if (res.success) {
            this.devices = [{
              key: 'root',
              title: '根节点',
              children: [

              ]
            }]
            res.result.records.forEach(device => {
              this.devices[0].children.push({
                key: device.id,
                title: device.videoName,
                slots: {
                  icon: 'online',
                },
                userData: device
              })
            });
          } else {
            this.$message.error(res.message)
          }
        })
      },
      changeSplit (e) {
        this.spilt = e.target.value - 0;
      },
      destroy (idx) {
        console.log(idx);
        this.clear(idx.substring(idx.length - 1))
      },
      clickEvent: function (data) {
        if (data.channelId && data.subCount == 0) {
          this.sendDevicePush(data)
        }
      },
      contextMenuEvent: function (data) {

      },
      selectDevice (selectedKeys, info) {
        const data = info.selectedNodes[0].data.props.userData;
        if (data.channelId) {
          this.sendDevicePush(data)
        }
      },
      //通知设备上传媒体流
      sendDevicePush: function (itemData) {
        if (itemData.status === 0) {
          this.$message.error('设备离线!');
          return
        }
        // this.save(itemData)
        let deviceId = itemData.deviceId;
        // this.isLoging = true;
        let channelId = itemData.channelId;
        console.log("通知设备推流1：" + deviceId + " : " + channelId);
        let idxTmp = this.playerIdx
        let that = this;
        this.loading = true
        const url = 'https://open.ys7.com/api/lapp/v2/live/address/get'
        getAction(url, {
          deviceSerial: deviceId,
          channelNo: channelId,
          protocol: 4,
          accessToken: 'at.4nz69ijd520yc0adak31xkz804z0dtoh-6bfw1lcmks-0lydm50-qg0r8rhvl'
        }).then(function (res) {
          console.log('=====----=====')
          console.log(res)
          if (res.data.code == 0 && res.data.data) {
            itemData.playUrl = res.data.data.httpsFlv
            that.setPlayUrl(res.data.data.ws_flv, idxTmp)
          } else {
            that.$message.error(res.data.msg);
          }
        }).catch(function (e) {
        }).finally(() => {
          that.loading = false
        });
      },
      setPlayUrl (url, idx) {
        this.$set(this.videoUrl, idx, url)
        let _this = this
        setTimeout(() => {
          window.localStorage.setItem('videoUrl', JSON.stringify(_this.videoUrl))
        }, 100)

      },
      checkPlayByParam () {
        let { deviceId, channelId } = this.$route.query
        if (deviceId && channelId) {
          this.sendDevicePush({ deviceId, channelId })
        }
      },
      shot (e) {
        const base64ToBlob = function (code) {
          let parts = code.split(';base64,');
          let contentType = parts[0].split(':')[1];
          let raw = window.atob(parts[1]);
          let rawLength = raw.length;
          let uInt8Array = new Uint8Array(rawLength);
          for (let i = 0; i < rawLength; ++i) {
            uInt8Array[i] = raw.charCodeAt(i);
          }
          return new Blob([uInt8Array], {
            type: contentType
          });
        };
        let aLink = document.createElement('a');
        let blob = base64ToBlob(e); //new Blob([content]);
        aLink.download = '截图';
        aLink.href = URL.createObjectURL(blob);
        var event = new Event('click');
        // Listen for the event.
        aLink.addEventListener('click', function (e) { }, false);
        // Dispatch the event.
        aLink.dispatchEvent(event);
      },
      save (item) {
        let dataStr = window.localStorage.getItem('playData') || '[]'
        let data = JSON.parse(dataStr);
        data[this.playerIdx] = item
        window.localStorage.setItem('playData', JSON.stringify(data))
      },
      clear (idx) {
        let dataStr = window.localStorage.getItem('playData') || '[]'
        let data = JSON.parse(dataStr);
        data[idx - 1] = null;
        console.log(data);
        window.localStorage.setItem('playData', JSON.stringify(data))
      },
    }
  };
</script>
<style>

  .btn {
    margin: 0 10px;
  }

  .btn:hover {
    color: #409eff;
  }

  .btn.active {
    color: #409eff;
  }

  .redborder {
    border: 2px solid red !important;
  }

  .play-box {
    background-color: #000000;
    border: 2px solid #505050;
    display: flex;
    align-items: center;
    justify-content: center;
  }

</style>
<style>

  .videoList {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
  }

  .video-item {
    position: relative;
    width: 15rem;
    height: 10rem;
    margin-right: 1rem;
    background-color: #000000;
  }

  .video-item-img {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 100%;
    height: 100%;
  }

  .video-item-img:after {
    content: '';
    display: inline-block;
    position: absolute;
    z-index: 2;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 3rem;
    height: 3rem;
    /* background-image: url('../assets/loading.png'); */
    background-size: cover;
    background-color: #000000;
  }

  .video-item-title {
    position: absolute;
    bottom: 0;
    color: #000000;
    background-color: #ffffff;
    line-height: 1.5rem;
    padding: 0.3rem;
    width: 14.4rem;
  }

</style>
